import {
  ContentMarginLeft,
  ContentPadding,
  ContentWidth,
  IContentLayoutContext,
} from 'component/layout/types';
import useTeamsState from 'hooks/stateHooks/useTeamsState';
import { useRouteMatch } from 'react-router-dom';

import { IContentContextProps } from '../Providers/ContentLayoutProvider/types';

/**
 * Executes actual logic determine Content layout context values.
 * See ContentLayoutProvider for props docs.
 * @param param0
 */
const useContentLayout = ({
  dashboardPaths = [],
  hasPanel = false,
  isDashboard: isDashboardProp = false,
}: IContentContextProps): IContentLayoutContext => {
  const { inTeamsChannelTab } = useTeamsState();

  /*
    Use large padding for web page.  Small for teams.
  */
  const paddingType = inTeamsChannelTab
    ? ContentPadding.SMALL
    : ContentPadding.LARGE;

  /*
    Default layout is full width.
  */
  let widthType = ContentWidth.FULL;
  let marginLeftType = ContentMarginLeft.LEFT_NAV;

  /**
   * Parent provided.  isDashboard prop trumps any route
   * paths provided.
   */
  const match = useRouteMatch({ path: dashboardPaths });
  const isDashboard = isDashboardProp || !!match;

  /*
    Teams uses full width always.  Otherwise dashboard
    layouts adjust width for presence of panel in the layout.
  */
  if (!inTeamsChannelTab && isDashboard) {
    widthType = hasPanel ? ContentWidth.SMALL : ContentWidth.MEDIUM;
  }

  if (inTeamsChannelTab) {
    marginLeftType = ContentMarginLeft.NONE;
  }

  return {
    marginLeftType,
    paddingType,
    widthType,
  };
};

export default useContentLayout;
